module.exports = __webpack_public_path__ + "static/media/Gus Santos.1008175e.png";